import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Award, CalendarDays } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { listarCertificados } from "../services/certificadoService";
import { formatCertificateDate } from "../utils/certificado";

const Certificados = () => {
  const [certificados, setCertificados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    // Descarta respostas atrasadas quando o usuario sai desta pagina.
    listarCertificados()
      .then((data) => { if (active) setCertificados(data); })
      .catch((err) => { if (active) setError(err.message || "Não foi possível carregar os certificados."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [attempt]);

  return (
    <div className="flex min-h-screen flex-col bg-[#FAF9F7] text-zinc-900 dark:bg-zinc-950 dark:text-zinc-100">
      <Header />
      <main className="mx-auto w-full max-w-screen-xl flex-1 px-4 pb-16 pt-32 sm:px-6 lg:px-8 lg:pt-28">
        <div className="mb-8 flex items-start gap-4">
          <span className="rounded-2xl bg-[#B95758]/10 p-3 text-[#B95758] dark:text-rose-300">
            <Award className="h-8 w-8" aria-hidden="true" />
          </span>
          <div>
            <h1 className="text-2xl font-bold sm:text-3xl">Meus certificados</h1>
            <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">Consulte e baixe os certificados dos seus cursos concluídos.</p>
          </div>
        </div>

        {loading ? (
          <p role="status" className="rounded-xl bg-white p-8 text-center shadow-sm dark:bg-zinc-900">Carregando certificados...</p>
        ) : error ? (
          <div role="alert" className="rounded-xl border border-red-200 bg-white p-6 dark:border-red-900 dark:bg-zinc-900">
            <p className="text-red-700 dark:text-red-300">{error}</p>
            <button type="button" onClick={() => setAttempt((value) => value + 1)} className="mt-4 rounded-lg bg-[#B95758] px-4 py-2 font-semibold text-white hover:bg-[#9f3f40]">Tentar novamente</button>
          </div>
        ) : certificados.length === 0 ? (
          <section className="rounded-2xl border border-dashed border-zinc-300 bg-white px-6 py-16 text-center dark:border-zinc-700 dark:bg-zinc-900">
            <Award className="mx-auto mb-4 h-12 w-12 text-[#B95758] dark:text-rose-300" aria-hidden="true" />
            <h2 className="text-xl font-semibold">Você ainda não tem certificados</h2>
            <p className="mt-2 text-zinc-600 dark:text-zinc-400">Conclua um curso e gere seu certificado para encontrá-lo aqui.</p>
            <Link to="/home" className="mt-6 inline-flex rounded-lg bg-[#B95758] px-5 py-3 font-semibold text-white hover:bg-[#9f3f40]">Ver cursos</Link>
          </section>
        ) : (
          <>
            <p className="mb-4 text-sm text-zinc-600 dark:text-zinc-400">{certificados.length} {certificados.length === 1 ? "certificado disponível" : "certificados disponíveis"}</p>
            <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {certificados.map((certificado) => (
                <li key={certificado.id_certificado}>
                  <Link to={"/certificados/" + certificado.id_certificado} className="group flex h-full flex-col rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:border-[#B95758]/60 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#B95758] dark:border-zinc-800 dark:bg-zinc-900">
                    <div className="mb-6 flex items-center justify-between">
                      <Award className="h-9 w-9 text-[#B95758] dark:text-rose-300" aria-hidden="true" />
                      <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">Concluído</span>
                    </div>
                    <h2 className="break-words text-lg font-bold">{certificado.nome_curso}</h2>
                    <p className="mt-2 break-words text-sm text-zinc-600 dark:text-zinc-400">{certificado.nome_completo}</p>
                    <div className="mt-auto pt-6">
                      <p className="flex items-center gap-2 text-sm text-zinc-600 dark:text-zinc-400">
                        <CalendarDays className="h-4 w-4" aria-hidden="true" />
                        Conclusão: <time dateTime={certificado.data_conclusao}>{formatCertificateDate(certificado.data_conclusao)}</time>
                      </p>
                      <span className="mt-5 flex items-center justify-between border-t border-zinc-100 pt-4 text-sm font-semibold text-[#B95758] dark:border-zinc-800 dark:text-rose-300">
                        Ver certificado <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" aria-hidden="true" />
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Certificados;
